import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { MatDialog } from "@angular/material";
import { ResultDialogComponent } from "../result-dialog/result-dialog.component";

import { AuthGuardService, UserService } from "@core/services";

@Component({
  selector: "app-update-email",
  templateUrl: "./update-email.component.html",
  styleUrls: ["./update-email.component.css"],
})
export class UpdateEmailComponent implements OnInit {
  updateEmail: FormGroup;
  public user: any;
  private subscription: Subscription;
  public errorMessage = "";
  constructor(
    private _fb: FormBuilder,
    private _userService: UserService,
    private _router: Router,
    private dialog: MatDialog,
    private _authGuard: AuthGuardService
  ) {}

  ngOnInit() {
    this.subscription = this._userService.getUser().subscribe((user) => {
      this.user = user;
    });
    this.updateEmail = this._fb.group({
      Email: new FormControl("", [Validators.required, Validators.email]),
    });

    if (this.user.customerIdArray.length > 0) {
      this._authGuard.getAccountInfo();
      this.updateEmail.setValue({Email: this.user.customerIdArray[this.user.customerIndex].WebUser.Email.trim()});
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onSubmit() {
    this.errorMessage = "";
    this.sendUpdateEmailDataToServer();
  }

  sendUpdateEmailDataToServer() {
    const emailData = this.setupEmail();
    const updateEmailEndpoint = "email/UpdateEmail";
    this._authGuard.authenticatedPost(updateEmailEndpoint, emailData).subscribe(
      (result) => {
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            title: "Success",
            message: result.toString(),
            alertType: "success",
          },
        });
        console.log("Success", result);
      },
      (error) => {
        let dialogRef = this.dialog.open(ResultDialogComponent, {
          data: {
            title: "Error",
            message: error,
            alertType: "danger",
          },
        });
        console.log("update email", error);
        this.errorMessage = error;
      }
    );
  }

  private setupEmail() {
    this.updateEmail
      .get("Email")
      .setValue(this.updateEmail.get("Email").value.toLowerCase());
    console.log("Update email form value", this.updateEmail.value);
    const emailData = this.updateEmail.value;
    return emailData;
  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-email/update-email.component.ts